(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vb-multipack-tiers"] && !Shopify.designMode) return;
  try {
    (function () {
    function initTiers(root) {
      if (root.dataset.vbmpInit === '1') return;
      root.dataset.vbmpInit = '1';

      var btn = root.querySelector('[data-vbmp-add]');
      var errorEl = root.querySelector('[data-vbmp-error]');
      if (!btn) return;

      function currentVariantId() {
        var form = document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');
        if (form) {
          var idInput = form.querySelector('[name="id"]');
          if (idInput && idInput.value) return idInput.value;
        }
        return root.dataset.variantId;
      }

      btn.addEventListener('click', function () {
        var checked = root.querySelector('input[name="' + root.id + '-tier"]:checked');
        var qty = checked ? parseInt(checked.dataset.qty, 10) : 1;
        if (!qty || qty < 1) qty = 1;
        var vid = currentVariantId();
        if (!vid) return;

        if (errorEl) errorEl.setAttribute('hidden', '');
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            if (root.dataset.afterAdd === 'drawer') {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
              var drawer = document.querySelector('cart-drawer, #cart-drawer, [ref="cartDrawer"]');
              if (drawer && typeof drawer.open === 'function') {
                drawer.open();
                btn.disabled = false;
                btn.textContent = label;
              } else if (drawer && drawer.showModal) {
                try { drawer.showModal(); btn.disabled = false; btn.textContent = label; }
                catch (e) { window.location = '/cart'; }
              } else {
                window.location = '/cart';
              }
            } else {
              window.location = '/cart';
            }
          })
          .catch(function () {
            if (errorEl) errorEl.removeAttribute('hidden');
            btn.disabled = false;
            btn.textContent = label;
          });
      });
    }

    document.querySelectorAll('.vbmp').forEach(initTiers);
    document.addEventListener('shopify:block:select', function (e) {
      var el = e.target.querySelector ? e.target.querySelector('.vbmp') : null;
      if (el) initTiers(el);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
